import booleanSelectCreator from '../util/booleanSelectCreator';
import dict from '../util/i18n';

export default booleanSelectCreator(dict.t('yes'), dict.t('no'));


// WEBPACK FOOTER //
// ./src/types/tmsYesNo.js